import type { Mouvement } from '@mairistem/comptabilite';
import { UserRole } from '@mairistem/finances-utils';
import BordereauStateStep from '../../../constants/liquidation/bordereaux/BordereauStateStep';
import BordereauStateType from '../../../constants/liquidation/bordereaux/BordereauStateType';
import type BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import type MouvementActionType from '../../../interfaces/pieces/mouvements/liquidation/MouvementActionType';
import type { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import MouvementModifierAction from '../../mouvements/liquidation/actions/MouvementModifierAction';
import type BaseLiquidationAction from '../../pieces/BaseLiquidationAction';
import BordereauDenumeroterAction from '../actions/BordereauDenumeroterAction';
import BordereauModifierAction from '../actions/BordereauModifierAction';
import BaseBordereauState from './BaseBordereauState';

class BordereauArchiveState extends BaseBordereauState {
	constructor() {
		super();
		this.step = BordereauStateStep.ARCHIVE;
		this.state = BordereauStateType.ARCHIVE;
		this.color = '#666A82';
		this.libelle = 'Archivé';
	}

	getBordereauActions(
		_bordereau: BordereauWithState,
		userRole: UserRole,
	): BaseLiquidationAction<BordereauWithState, BordereauActionType>[] {
		return [
			// bordereau de rejet archivé : ni annulation ni rejet (BordereauAnnulerAction et
			// MouvementAnnulerRejeterAction écartent les bordereaux de rejet), seulement les actions d'administrateur
			...(userRole === UserRole.ADMIN
				? [
						new BordereauDenumeroterAction({
							isRejet: true,
							isSuperUser: true,
						}),
						new BordereauModifierAction({ isSuperUser: true }),
					]
				: []),
		];
	}

	getMouvementActions(
		userRole: UserRole,
	): BaseLiquidationAction<Mouvement, MouvementActionType>[] {
		return [
			new MouvementModifierAction({ isReadonly: true }),
			...(userRole === UserRole.ADMIN
				? [new MouvementModifierAction({ isSuperUser: true })]
				: []),
		];
	}
}

export default BordereauArchiveState;
